import { formatTimestamp } from '../../../utils/dateUtils';
import { checkOverflow } from '../../../utils/utilFunctions';

import Tooltip from '@mui/material/Tooltip';
import StyledWrapper from '../style';

const BasicCellText = ({
	cellValues,
	openTooltip,
	setOpenTooltip,
	StartIcon,
	IconStatus,
	isLink,
	isDate
}) => {
	const formattedText = isDate
		? formatTimestamp(cellValues?.formattedValue)
		: cellValues?.formattedValue;

	return (
		<Tooltip
			open={openTooltip === `${cellValues?.field}-${cellValues?.id}`}
			onOpen={(e) =>
				checkOverflow(e) &&
				setOpenTooltip &&
				setOpenTooltip(`${cellValues?.field}-${cellValues?.id}`)
			}
			onClose={() => setOpenTooltip && setOpenTooltip(0)}
			arrow
			placement="top"
			title={cellValues?.formattedValue && formattedText}
		>
			<StyledWrapper.CellContainer
				data-testid={`cellContainer-${cellValues?.field}-${cellValues?.id}`}
			>
				{cellValues?.formattedValue && StartIcon && <StartIcon status={IconStatus} />}
				{!isLink ? (
					<StyledWrapper.CardRowInfo
						width={'100%'}
						data-testid={`rowInfo-${cellValues?.field}-${cellValues?.id}`}
					>
						{cellValues?.formattedValue && formattedText}
					</StyledWrapper.CardRowInfo>
				) : (
					<StyledWrapper.CardRowInfoLink
						width={'100%'}
						data-testid={`rowLink-${cellValues?.field}-${cellValues?.id}`}
					>
						{cellValues?.formattedValue && formattedText}
					</StyledWrapper.CardRowInfoLink>
				)}
			</StyledWrapper.CellContainer>
		</Tooltip>
	);
};

export default BasicCellText;
